import InfiniteScroll from 'react-infinite-scroll-component'

import { ProductPreviewCard } from '@widgets/product-preview'

import {
  Product,
} from '@shared/generated'
import CardSkeleton from '@shared/ui/card-skeleton'

import styles from './styles.module.scss'

type ProductsInfiniteScrollProps = {
  products?: Product[] | null;
  loading?: boolean;
  fetchNextPage: () => void;
  hasMore: boolean;
  loadingMore?: boolean;
};

function ProductsLoading () {
  return (
    <div className={styles.root}>
      {Array.from({ length: 8 }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  )
}

export default function ProductsInfiniteScroll ({ 
  products,
  loading,
  fetchNextPage,
  hasMore,
  loadingMore
}: ProductsInfiniteScrollProps) {
  
  if (loading && products?.length === 0) {
    return <ProductsLoading />
  }

  if (!products || products.length === 0) {
    return null
  }

  return (
    <InfiniteScroll
      dataLength={products.length}
      next={fetchNextPage}
      hasMore={hasMore}
      loader={loadingMore && <ProductsLoading />}
    >
      <section className={styles.root}>
        {products.map((p) => (
          <ProductPreviewCard
            key={p.id}
            className={styles.card}
            data={p as Product}
          />
        ))}
      </section>
    </InfiniteScroll>
  )
}
